import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

export const Route = createFileRoute('/_authenticated/company/connectors')({
  beforeLoad: requireOrgAdminBeforeLoad
}).lazy(() => import('./connectors.lazy').then((d) => d.Route));
